import React from "react";
import { compose } from "redux";
import { injectIntl } from "react-intl";

import { useWindowWidth } from "hooks";
import { debounce } from "utils";
import { CustomizableForm } from "components/client/Form/CustomizableForm";
import { FlexGrid, FlexGridItem } from "components/base/FlexGrid";
import { BaseInputField } from "components/base/BaseForm";
import FormHOC from "hoc/FilltersForm";
import m from "definedMessages";

import { Form, Schema } from "rsuite";

const { StringType } = Schema.Types;

const MAX_CHARACTERS = 40;

const LiveCallsFilters = (({
    loading,
    onChangeFilters,
    savedTableFilter,
    intl
}) => {

    const { formatMessage } = intl;

    const filtersModel = Schema.Model({
        number_destination: StringType().maxLength(MAX_CHARACTERS, formatMessage(m.maxLength, { count: MAX_CHARACTERS }))
    }
    );

    const resizedWidth = useWindowWidth();

    const onSubmit = (data, checkedData) => {
        const checker = Object.keys(checkedData)
            .map(i => checkedData[i].hasError)
            .every(value => value === false);

        if (checker) {
            onChangeFilters({ ...data });
        }
        return false;
    };

    return (
        <CustomizableForm
            model={filtersModel}
            formDefaultValue={savedTableFilter || { number_destination: "" }}
            onChange={debounce((data) => {
                const checkedData = filtersModel.check(data);
                onSubmit(data, checkedData);
            }, 1000)}
            fluid
            readOnly={loading}
        >
            <FlexGrid align="middle">
                <FlexGridItem width="260px">
                    <Form.Control
                        accepter={BaseInputField}
                        name="number_destination"
                        errorPlacement="topEnd"
                        placeholder={resizedWidth > 300 ? formatMessage(m.filterPerNumOrDest) : "Numbers/Destination"}
                    />
                </FlexGridItem>
            </FlexGrid>
        </CustomizableForm>
    );
});

export default compose(
    FormHOC,
    injectIntl
)(LiveCallsFilters)
